export default __webpack_public_path__ + "static/Group6-70cd3b5232117af4e5b603958088c868.png";